var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('seccion-slider'),_c('seccion-cob'),_c('seccion-planes'),_c('preguntas-respuestas'),_c('nosotros')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }